
import { signoutAuthUser } from "@/services/firebase";
import { FC, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const Logout: FC = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        signoutAuthUser().then(() => setLoading(false));
    }, []);


    
    return loading ? null : <Navigate to="/login" />;
}

export default Logout;